// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"fa277bdb","164":"ea63c3eb","806":"b32a168d","827":"7c02250a","952":"a0af0ea8","972":"363a3a54"}[chunkId] + ".chunk.js";
};